import type { PsHttpSSE } from '@/services/sse-ps-http/sse-ps-http';
import type { SpecificationStreamContent } from '../types/specification';

export type GenFeatureTreeRequest = {
    /** 任务ID */
    task_id: string;

    /** 操作类型 */
    operate_type?: string;
};

export type FeatureTree = {
    /** 权利要求编号 */
    num: string;

    /** 权利要求内容 */
    simple_claim: string;

    /** 特征列表 */
    claim_features?: {
        /** 特征内容, 特征短语 */
        feature: string;
        /** 特征词列表 */
        concepts?: string[];
    }[];

    /** 从权才有这个值，代表其附属于哪个主权, 可能有多个 , 隔开 */
    parent?: string;
}[];

export interface GenFeatureTreeResponse {
    /** 权利要求、特征树 */
    feature_tree?: FeatureTree;
}

export const GenFeatureTreeApi = Symbol.for('GenFeatureTreeApi');

export interface GenFeatureTreeApi {
    genFeatureTree(data: GenFeatureTreeRequest): PsHttpSSE<SpecificationStreamContent<GenFeatureTreeResponse>>;
}
